import { Component } from 'preact';
import TableCell from './tableCell'

export default class compareTable extends Component {

  constructor() {
		super();
		// set initial time:
		this.state = { test: null };
	}

  componentWillMount(){
    let {tableData, compareProducts} = this.props
    let tableRows = tableData && tableData.rows ?  tableData.rows : []
    tableRows.push( {id: 'moreContent'})

    this.setState({tableRows, compareProducts })
  }

  render(){


    let {compareProducts, tableRows} = this.state
    let grid = []
    let index = 0
    let arrayLength = tableRows.length -1

    tableRows.forEach ( currentRow=> {

        let rowBackgroundColor = index % 2 ? '#F5FBFF' : '#DDECF3'
        let row = []

        //first we need to add our label cell to the row
        rowBackgroundColor =  index === 0  || arrayLength === index ? '#fff' : rowBackgroundColor
        row.push(	<div style={{flex: 1, padding: '15px', backgroundColor: rowBackgroundColor , overflow: 'hidden'}}><b>{currentRow.label}</b></div>)

          compareProducts.map( current =>  {
              let currentItem = this.props.compareItemsContent[current.itemId]
              row.push(<TableCell currentItem={currentItem} currentRow={currentRow} rowBackgroundColor={rowBackgroundColor} {...this.props} />)
            })

        grid.push(<div style={{display: 'flex', flex:1}}>{row}</div>)
        index++
    })

		return (
			<div style={{flex: 1, borderLeft: "1px #ddd solid", borderTop: "1px #ddd solid", borderRight: "1px #ddd solid", borderBottom: '1px #ddd solid .75em transparent'}}>

        {grid}

			</div>
		);
  }

}



// WEBPACK FOOTER //
// ./components/contentTypes/compareTable/table.js